import { render } from "./SectionsPageView.vue?vue&type=template&id=1f0482da&scoped=true"
import script from "./SectionsPageView.vue?vue&type=script&lang=js"
export * from "./SectionsPageView.vue?vue&type=script&lang=js"

import "./SectionsPageView.vue?vue&type=style&index=0&id=1f0482da&lang=scss"
import "./SectionsPageView.vue?vue&type=style&index=1&id=1f0482da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f0482da"]])

export default __exports__